var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-column items-center justify-center center",attrs:{"id":"Home"}},[_c('WebCam',{staticClass:"w-100"}),_c('Upload',{staticClass:"w-100"}),_c('Display',{staticClass:"w-100"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }